<!--<app-sidebar></app-sidebar>-->
<app-header [ngClass]="{sidebarShow: mainService.sidebarShow$ | async}"></app-header>
<div class="outlet-wrapper" [ngClass]="{sidebarShow: mainService.sidebarShow$ | async}">
  <router-outlet></router-outlet>
</div>
<div class="loading" *ngIf="mainService.loading$ | async"><mat-spinner></mat-spinner></div>
